var map = {
	"./8b9c157c-4a28-40ca-b374-91c4cbf7a735.jpg": 4005,
	"./a067cf84-4475-4013-9f50-f17acb9e91ca.jpg": 5060,
	"./fc6ed670-2497-491d-8ba6-93a45d4b6f93.jpg": 4349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1320;